import { Spinner } from "@/components/spinner";
import { cn } from "@/utils";

type LoadingOverlayProps = React.ComponentProps<"div"> & {
  fullscreen?: boolean;
  spinnerClassName?: string;
};

export default function LoadingOverlay({
  className,
  fullscreen = true,
  spinnerClassName,
  ...props
}: LoadingOverlayProps) {
  return (
    <div
      data-slot="loading-overlay"
      className={cn(
        fullscreen ? "fixed z-100" : "absolute z-10",
        "inset-0 flex items-center justify-center transition-opacity duration-300",
        className
      )}
      {...props}
    >
      <Spinner className={cn("size-50", spinnerClassName)} />
    </div>
  );
}
